import { inject, Injectable } from '@angular/core';
import { hasActionsExecuting } from '@ngxs-labs/actions-executing';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import {
  CalculateInvoiceAmounts,
  InitCertifiedInvoice,
  InitDraftInvoice,
  PatchDraftInvoice,
  PatchInvoiceLine,
  RemoveInvoiceLine,
  ResetState
} from '../actions/invoice.actions';
import { InvoiceState } from '../states/invoice.state';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';

@Injectable()
export class InvoiceFacade {
  protected _store = inject(Store);

  draft$ = this._store.select(InvoiceState.draft);

  @SelectSnapshot(InvoiceState.draft) draft!: ReturnType<
    typeof InvoiceState.draft
  >;

  readonly isResettingState$ = this._store.select(
    hasActionsExecuting([ResetState])
  );

  // Action Dispatchers
  resetState(
    ...params: ConstructorParameters<typeof ResetState>
  ): Observable<unknown> {
    return this._store.dispatch(new ResetState(...params));
  }

  initDraftInvoice(
    ...params: ConstructorParameters<typeof InitDraftInvoice>
  ): Observable<unknown> {
    return this._store.dispatch(new InitDraftInvoice(...params));
  }

  initCertifiedInvoice(
    ...params: ConstructorParameters<typeof InitCertifiedInvoice>
  ): Observable<unknown> {
    return this._store.dispatch(new InitCertifiedInvoice(...params));
  }

  patchDraftInvoice(
    ...params: ConstructorParameters<typeof PatchDraftInvoice>
  ): Observable<unknown> {
    return this._store.dispatch(new PatchDraftInvoice(...params));
  }

  patchInvoiceLine(
    ...params: ConstructorParameters<typeof PatchInvoiceLine>
  ): Observable<unknown> {
    return this._store.dispatch(new PatchInvoiceLine(...params));
  }

  removeInvoiceLine(
    ...params: ConstructorParameters<typeof RemoveInvoiceLine>
  ): Observable<unknown> {
    return this._store.dispatch(new RemoveInvoiceLine(...params));
  }

  calculateInvoiceAmounts(
    ...params: ConstructorParameters<typeof CalculateInvoiceAmounts>
  ): Observable<unknown> {
    return this._store.dispatch(new CalculateInvoiceAmounts(...params));
  }
}
